import React from 'react';
import loadable from '@loadable/component';
const MortgageCalculator = loadable(() =>
  import('components/components/organisms/MortgageCalculator'),
);

const MortgageCalculatorContainer = ({ fields, rendering }) => {
  return <MortgageCalculator fields={fields} rendering={rendering} />;
};

export default MortgageCalculatorContainer;
